module.exports = __webpack_public_path__ + "media/images/users/user-4-35cd90700e60afa6b073b7a15aa629ce.jpg";